import { render, staticRenderFns } from "./NavTabsLayout.vue?vue&type=template&id=d71a2bb8&"
import script from "./NavTabsLayout.vue?vue&type=script&lang=js&"
export * from "./NavTabsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports